import React from "react";
const idRol = Number(sessionStorage.getItem("idRol"));
const esAdmin = idRol === 5;

const InduccionesSection = ({
  induccionesAsignadas,
  formatFecha,
  onVerDocumentos,
  onPlanInduccion,
  onRealizarFormulario,
  onVerComentarios
}) => {
  return (
    <div
      style={{
        background: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        marginTop: "30px",
      }}
    >
      <h4
        style={{
          marginBottom: "20px",
          color: "#219ebc",
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Inducciones asignadas</span>

        <span
          onClick={onPlanInduccion}
          style={{
            color: "#219ebc",
            fontSize: "13px",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: "500",
          }}
        >
          {esAdmin
            ? "Subir plan de inducción"
            : "Descargar plan de inducción"}
        </span>
      </h4>

      {induccionesAsignadas.length === 0 ? (
        <p style={{ fontSize: "16px", margin: 0 }}>
          No hay inducciones asignadas.
        </p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "16px",
          }}
        >
          <thead>
            <tr style={{ borderBottom: "2px solid #ddd", textAlign: "left" }}>
              <th
                style={{
                  padding: "14px",
                  background: "#f8f9fa",
                  fontWeight: "600",
                }}
              >
                Nombre de la inducción
              </th>
              <th
                style={{
                  padding: "14px",
                  background: "#f8f9fa",
                  fontWeight: "600",
                  width: "200px",
                }}
              >
                Fecha de inicio
              </th>

              <th style={{ padding: "14px", background: "#f8f9fa", fontWeight: "600", width: "180px" }}>
                Formulario
              </th>
              <th style={{ padding: "14px", background: "#f8f9fa", fontWeight: "600", width: "180px" }}>
                Ver Comentarios
              </th>
              <th
                style={{
                  padding: "14px",
                  background: "#f8f9fa",
                  fontWeight: "600",
                  width: "160px",
                }}
              >
                Documentos
              </th>
            </tr>
          </thead>
          <tbody>
            {induccionesAsignadas.map((ind) => (
              <tr key={ind.idinduccion} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "14px" }}>{ind.nombre}</td>

                <td style={{ padding: "14px" }}>
                  {formatFecha(ind.fechainicio)}
                </td>

                {/* 👇 BOTÓN FORMULARIO */}
                <td style={{ padding: "14px" }}>
                  {(ind.formularios || []).length === 0 ? (
                    <span style={{ color: "#6b7280", fontSize: "14px" }}>
                      Sin formularios
                    </span>
                  ) : (
                    <select
                      defaultValue=""
                      onChange={(e) => {
                        const f = ind.formularios.find(
                          x => x.id === Number(e.target.value)
                        );

                        if (f) {
                          onRealizarFormulario(f);
                          e.target.value = ""; // vuelve al placeholder
                        }
                      }}
                      style={{
                        width: "100%",
                        minWidth: "220px",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        border: "1px solid #d1d5db",
                        background: "#fff",
                        color: "#023047",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                        outline: "none",
                        transition: "0.2s"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#219ebc";
                        e.target.style.boxShadow = "0 0 0 3px rgba(33,158,188,.15)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#d1d5db";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      <option value="">Seleccionar formulario...</option>

                      {ind.formularios.map((f) => (
                        <option
                          key={f.id}
                          value={f.id}
                          disabled={f.respondido}
                        >
                          {f.formulario.titulo}
                          {f.respondido ? " ✓ Respondido" : ""}
                        </option>
                      ))}
                    </select>
                  )}
                </td>

                <td style={{ padding: "14px" }}>
                  {(ind.formularios || []).length === 0 ? (
                    <span
                      style={{
                        color: "#6b7280",
                        fontSize: "14px"
                      }}
                    >
                      Sin formularios
                    </span>
                  ) : (
                    <select
                      defaultValue=""
                      onChange={(e) => {
                        const formulario = ind.formularios.find(
                          f => f.id === Number(e.target.value)
                        );

                        if (formulario) {
                          onVerComentarios(ind, formulario);
                          e.target.value = "";
                        }
                      }}
                      style={{
                        width: "100%",
                        minWidth: "220px",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        border: "1px solid #d1d5db",
                        background: "#fff",
                        color: "#023047",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                        outline: "none",
                        transition: "0.2s"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#8ecae6";
                        e.target.style.boxShadow =
                          "0 0 0 3px rgba(142,202,230,.25)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#d1d5db";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      <option value="">
                        Ver comentarios...
                      </option>

                      {ind.formularios.map((f) => (
                        <option
                          key={f.id}
                          value={f.id}
                        >
                          {f.formulario.titulo}
                        </option>
                      ))}
                    </select>
                  )}
                </td>

                <td style={{ padding: "14px" }}>
                  <button
                    onClick={() => onVerDocumentos(ind)}
                    style={{
                      padding: "8px 14px",
                      background: "#219ebc",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    Ver documentos
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default InduccionesSection;
